export default {
  getCurrentToken() {
    return this.currentToken
  },
  getPayload() {
    return this.payload
  },
  getCurrentPartner() {
    return this.currentPartner
  },
  getAppTranslation() {
    return this.appTranslations
  }
}
